module.exports = __webpack_public_path__ + "static/img/下.b02f491.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/下.png
// module id = geTT
// module chunks = 16